/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { KeyType } from '../../models/key-type';
import { NameType } from '../../models/name-type';

export interface PutConsigneeSelfCheckinLegalDocument$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
  fileName: NameType;
      body: BinaryFileType
}

export function putConsigneeSelfCheckinLegalDocument(http: HttpClient, rootUrl: string, params: PutConsigneeSelfCheckinLegalDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, putConsigneeSelfCheckinLegalDocument.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('fileName', params.fileName, {});
    rb.body(params.body, 'application/pdf');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

putConsigneeSelfCheckinLegalDocument.PATH = '/administration/organization-sites/{organizationSiteKey}/self-checkin/legal-document/{fileName}';
